import { useManagementSubscriptionContext } from "./Context";
import { useEffect } from "react";
import { getBotbPrizeStraplineTexts } from "../botb-pass/subscription-service";
import { CompetitionPrizeTypes } from "./types";

const Step3 = () => {
  const { subscriptionPlan, straplineTexts, setStraplineTexts, totalEntries, onNext, onCancelSubscriptionModal } =
    useManagementSubscriptionContext();
  const numberFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const greenValue =
    subscriptionPlan.interval === "month"
      ? numberFormat.format(subscriptionPlan.amount / 100 / 30)
      : numberFormat.format(subscriptionPlan.amount / 100 / 365);
  useEffect(() => {
    getBotbPrizeStraplineTexts()
      .then(res => res.json())
      .then((res: CompetitionPrizeTypes) => {
        setStraplineTexts(res);
      })
      .catch(err => console.error(err));
  }, []);
  return (
    <div data-name={"modal-step-3"} className={"h-full grow flex flex-col"}>
      <div className={"scroll-wrapper grow relative mb-4 lg:mb-5"}>
        <div className={"max-lg:absolute max-lg:inset-0 size-full max-lg:overflow-y-auto"}>
          <div className={"mb-4"}>
            <div
              className={
                "text-dark-1 text-center font-jost text-xl font-semibold leading-6.5 mb-1.5 max-lg:max-w-[262px] mx-auto lg:text-[28px] lg:leading-8"
              }>
              Remember what our winners always say?
            </div>
          </div>
          <div
            className={
              "mb-5 text-xl leading-6.5 uppercase text-center font-semibold lg:text-[28px] lg:leading-8 font-jost"
            }>
            You gotta <span className={"text-primary text-underline-special-double"}>be in it to win it</span>
          </div>
          <div className={"lg:max-w-[490px] mx-auto"}>
            <div
              className={
                "mb-4 flex flex-col items-center rounded-lg bg-white shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.08)] border border-gray-7"
              }>
              <div
                className={
                  "text-sm font-jost rounded-t-lg bg-red-1 text-white text-center w-full flex justify-center items-center gap-2.5 px-2.5 py-0.5 lg:px-2 lg:py-1 lg:text-lg lg:font-medium lg:leading-6"
                }>
                <span role={"img"} aria-label={"What you will lose access to"}>
                  😔
                </span>{" "}
                What you will lose access to
              </div>
              <div className={" rounded-b-lg w-full pt-2 lg:pt-3 pb-3 lg:pb-4"}>
                <div
                  className={
                    "mb-5 text-xs font-jost text-gray-1 text-center max-w-[224px] lg:max-w-[378px] mx-auto lg:text-sm lg:leading-5"
                  }>
                  You&apos;ll stop receiving{" "}
                  <strong className={"text-dark-1 font-medium"}>
                    {totalEntries ? totalEntries : 0} monthly chances
                  </strong>{" "}
                  to win from a prize pool worth over <strong className={"text-dark-1 font-medium"}>£2.3M</strong>
                </div>
                <div className={"flex items-center justify-center gap-3 lg:gap-6 px-4 mb-5 lg:mb-2.5"}>
                  <div className={"inline-flex lg:flex-col items-center gap-2.5 lg:gap-1"}>
                    <img
                      src={"/assets/images/subscriptions/dream-car-m.webp"}
                      alt={"Dream cars"}
                      width={45}
                      height={32}
                      className={"w-[45px] h-auto lg:hidden"}
                    />
                    <img
                      src={"/assets/images/subscriptions/dream-car-d.webp"}
                      alt={"Dream cars 2"}
                      width={103}
                      height={64}
                      className={"h-auto w-[103px] hidden lg:block"}
                    />
                    <span
                      className={
                        "text-xs text-[#4C4C52] font-jost font-medium max-lg:max-w-10 lg:text-sm lg:leading-5"
                      }>
                      Dream cars
                    </span>
                  </div>
                  <div className={"inline-flex lg:flex-col items-center gap-2.5 lg:gap-1"}>
                    <img
                      src={"/assets/images/subscriptions/new-houses-m.webp"}
                      alt={"New houses"}
                      width={45}
                      height={32}
                      className={"w-[45px] h-auto lg:hidden"}
                    />
                    <img
                      src={"/assets/images/subscriptions/new-houses-d.webp"}
                      alt={"New houses 2"}
                      width={103}
                      height={64}
                      className={"h-auto w-[103px] hidden lg:block"}
                    />
                    <span
                      className={
                        "text-xs text-[#4C4C52] font-jost font-medium max-lg:max-w-10 lg:text-sm lg:leading-5"
                      }>
                      New houses
                    </span>
                  </div>
                  <div className={"inline-flex lg:flex-col items-center gap-2.5 lg:gap-1"}>
                    <img
                      src={"/assets/images/subscriptions/cash-prizes-m.webp"}
                      alt={"Cash prizes"}
                      width={45}
                      height={32}
                      className={"w-[45px] h-auto lg:hidden"}
                    />
                    <img
                      src={"/assets/images/subscriptions/cash-prizes-d.webp"}
                      alt={"Cash prizes 2"}
                      width={103}
                      height={64}
                      className={"h-auto w-[103px] hidden lg:block"}
                    />
                    <span
                      className={
                        "text-xs text-[#4C4C52] font-jost font-medium max-lg:max-w-10 lg:text-sm lg:leading-5"
                      }>
                      Cash prizes
                    </span>
                  </div>
                </div>
                <div>
                  <p className={"text-[11px] leading-3.5 text-gray-1 text-center font-jost lg:text-sm lg:leading-5"}>
                    <span
                      className={
                        "bg-clip-text text-transparent bg-gradient-to-r from-[#EE0979] to-[#FF6A00] font-semibold"
                      }>
                      Life changing prizes
                    </span>{" "}
                    could be just 1 ticket away
                  </p>
                </div>
              </div>
            </div>
            <div
              className={
                "mb-4 flex flex-col items-center rounded-lg bg-white shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.08)] border border-gray-7"
              }>
              <div className={"rounded-t-lg bg-green-1 w-full py-1 relative flex items-center justify-center px-2.5"}>
                <div className={"text-xs font-jost text-white text-center lg:text-lg lg:font-medium lg:leading-6"}>
                  <span role={"img"} aria-label={"What you will lose access to"}>
                    🎉
                  </span>{" "}
                  What they won
                </div>
                <div
                  className={
                    "absolute right-2.5 lg:right-2 top-1/2 -translate-y-1/2 text-center rounded-full py-0.5 px-1.5 bg-yellow-1 text-green-2 text-[10px] font-jost font-medium leading-none lg:text-xs lg:leading-4"
                  }>
                  25 Years of History
                </div>
              </div>
              <div className={"rounded-b-lg w-full pt-2 lg:pt-3.5 lg:pb-4 pb-3 flex items-center justify-center"}>
                <div className={"inline-flex items-center gap-3"}>
                  <img
                    src={"/assets/images/subscriptions/trophy.webp"}
                    alt={"cars-only"}
                    width={20}
                    height={21}
                    className={"w-5 lg:w-8 h-auto"}
                  />
                  <span
                    className={
                      "text-gray-1 text-[11px] font-jost leading-4 max-lg:max-w-[54px] lg:text-base lg:leading-5.5"
                    }>
                    <strong className={"font-medium text-[#4C4C52]"}>{straplineTexts.PrizeStraplineText3}</strong>{" "}
                    Winners
                  </span>
                </div>
                <div className={"w-0.5 h-6 bg-black/[.08] mx-6 lg:mx-5"}></div>
                <div className={"inline-flex items-center gap-3"}>
                  <img
                    src={"/assets/images/subscriptions/prizes.webp"}
                    alt={"cars-only"}
                    width={20}
                    height={21}
                    className={"w-5 lg:w-8 h-auto"}
                  />
                  <span
                    className={
                      "text-gray-1 text-[11px] font-jost leading-4 max-lg:max-w-[54px] lg:text-base lg:leading-5.5"
                    }>
                    <strong className={"font-medium text-[#4C4C52]"}>{straplineTexts.PrizeStraplineText2}</strong> in
                    Prizes Won
                  </span>
                </div>
              </div>
            </div>
            <div className={"text-center font-jost text-xs text-black leading-5.5 lg:text-base"}>
              <span role={"img"} aria-label={"What you will lose access to"}>
                🚀
              </span>{" "}
              Don’t miss your next shot for{" "}
              <span className={"text-base"}>
                <strong>only</strong> <strong className={"text-green-1"}>{greenValue}/day</strong>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={"flex gap-2 lg:justify-end"}>
        <button onClick={onNext} className={"theme-btn theme-btn-md uppercase max-lg:w-full text-primary"}>
          Cancel anyway
        </button>
        <button
          onClick={onCancelSubscriptionModal}
          className={"theme-btn theme-btn-primary theme-btn-md uppercase max-lg:w-full"}>
          Keep subscription
        </button>
      </div>
    </div>
  );
};

export default Step3;
